import Axios from "../../node_modules/axios";
import {ui,framework} from 'saffroncodejs';

import { Home } from "../components/Home/Home";
import { Login } from "../components/Login/login";
import { Post } from "../components/Page/Post";
import ListCollapse from "../components/ListCollapse/ListCollapse";
import SearchList from "../components/SearchList/SearchList";
import { Inquiry } from "../components/Inquiry/Inquiry";
import ListViewBranch from "../components/ListView/ListViewBranch";
import ListViewNamayandegi from "../components/ListView/ListViewNamayandegi";
import Bimenamesalessayer from "../components/EtelaatBimeSayerSherkatha/Bimenamesalessayer";
import BimenamesalessayerResult from "../components/EtelaatBimeSayerSherkatha/BimenamesalessayerResult";
import daryaftman from "../components/Daryafti/daryaftman";
import Details from "../components/ListCollapse/Details";
import Khesarat from "../components/Khesarat/Khesarat";
import AtashSuzi from "../components/ListCollapse/AtashSuzi";
import Badane from "../components/ListCollapse/Badane";
import HavadesGuruhi from "../components/ListCollapse/HavadesGuruhi";
import AtashsuziGHeirSanati from "../components/ListCollapse/AtashsuziGHeirSanati";
import AtashsuziMaskuni from "../components/ListCollapse/AtashsuziMaskuni";
import AtashSuziAnbar from "../components/ListCollapse/AtashSuziAnbar";
import BarbariDakheli from "../components/ListCollapse/BarbariDakheli";
import BarbariVaredati from "../components/ListCollapse/BarbariVaredati";
import BarbariSaderati from "../components/ListCollapse/BarbariSaderati";
import Pezeshkan from "../components/ListCollapse/Pezeshkan";
import PiraPezeshkan from "../components/ListCollapse/PiraPezeshkan";
import Hamlonaghl from "../components/ListCollapse/Hamlonaghl";
import Abnie from "../components/ListCollapse/Abnie";
import Sanati from "../components/ListCollapse/Sanati";
import Omrani from "../components/ListCollapse/Omrani";
import KarfarmaSakhtemani from "../components/ListCollapse/KarfarmaSakhtemani";
import Madani from "../components/ListCollapse/Madani";
import OmrvaSarmayegozari from "../components/ListCollapse/OmrvaSarmayegozari";
import MashinAlat from "../components/ListCollapse/MashinAlat";
import SazehayeTakmilshode from "../components/ListCollapse/SazehayeTakmilshode";
import SHekastMashinAlat from "../components/ListCollapse/SHekastMashinAlat";
import TajhizatElekteroniki from "../components/ListCollapse/TajhizatElekteroniki";
import Tamamkhatar from "../components/ListCollapse/Tamamkhatar";
import Sayer from "../components/ListCollapse/Sayer";
import Havapeyma from "../components/ListCollapse/Havapeyma";
import PulDarJaryan from "../components/ListCollapse/PulDarJaryan";
import Keshti from "../components/ListCollapse/Keshti";
import Axa from "../components/ListCollapse/Axa";
import SOS from "../components/ListCollapse/SOS";
import MapFree from "../components/ListCollapse/MapFree";
import HavadesEnferadi from "../components/ListCollapse/HavadesEnferadi";
import TamamKHatarPeymankari from "../components/ListCollapse/TamamKHatarPeymankari";
import OmrGuruhi from "../components/ListCollapse/OmrGuruhi";
import OmrEnferadi from "../components/ListCollapse/OmrEnferadi";
import Marhunati from "../components/ListCollapse/Marhunati";
import TashkilSarmaye from "../components/ListCollapse/TashkilSarmaye";
import Darman from "../components/ListCollapse/Darman";
import OyoubAsasiVapenhan from "../components/ListCollapse/OyoubAsasiVapenhan";
import ASB from "../components/ListCollapse/ASB";
import PulDarSandogh from "../components/ListCollapse/PulDarSandogh";
import HavaleKHesarat from "../components/Khesarat/HavaleKHesarat";
import BarBariDakheliKH from "../components/Khesarat/BarBariDakheliKH";
import Sales from "../components/Khesarat/Sales";
import SalesMali from "../components/Khesarat/SalesMali";
import SarNeshin from "../components/Khesarat/SarNeshin";
import Pishnehadha from "../components/PishnehadEnteghad/Pishnehadha";
import AtashSuziSanati from "../components/Khesarat/AtashSuziSanati";
import AtashSuziGHeirSanatiKH from "../components/Khesarat/AtashSuziGHeirSanatiKH";
import BadaneKH from "../components/Khesarat/BadaneKH";
import HavadesGuruhiKH from "../components/Khesarat/HavadesGuruhiKH";
import HavadesEnferadiKH from "../components/Khesarat/HavadesEnferadiKH";
import BarbariVaredatikh from "../components/Khesarat/BarbariVaredatikh";
import BarbariSaderatikh from "../components/Khesarat/BarbariSaderatikh";
import PezeshkanKH from "../components/Khesarat/PezeshkanKH";
import PiraPezeshkanKH from "../components/Khesarat/PiraPezeshkanKH";
import HamlonaghlKH from "../components/Khesarat/HamlonaghlKH";
import AbnieKH from "../components/Khesarat/AbnieKH";
import SanatiBazarganiKH from "../components/Khesarat/SanatiBazarganiKH";
import OmraniKH from "../components/Khesarat/OmraniKH";
import KarfarmaSakhtemaniKH from "../components/Khesarat/KarfarmaSakhtemaniKH";
import MadaniKH from "../components/Khesarat/MadaniKH";
import OmrVaSarmayegozariKH from "../components/Khesarat/OmrVaSarmayegozariKH";
import AxaKH from "../components/Khesarat/AxaKH";
import ASBKH from "../components/Khesarat/ASBKH";
import SosKH from "../components/Khesarat/SosKH";
import MashinAlatPeymankarikh from "../components/Khesarat/MashinAlatPeymankarikh";
import TajhizatElektronikiKH from "../components/Khesarat/TajhizatElektronikiKH";
import SazehayeTakmilshodeKH from "../components/Khesarat/SazehayeTakmilshodeKH";
import SHekastMashinAlatKH from "../components/Khesarat/SHekastMashinAlatKH";
import TamamkhatarKH from "../components/Khesarat/TamamkhatarKH";
import SayerKH from "../components/Khesarat/SayerKH";
import HavapeymaKH from "../components/Khesarat/HavapeymaKH";
import PoolKH from "../components/Khesarat/PoolKH";
import PoolSandoghKH from "../components/Khesarat/PoolSandoghKH";
import AtashSuziMaskuniKH from "../components/Khesarat/AtashSuziMaskuni";
import AtashSuziAnbarkh from "../components/Khesarat/AtashSuziAnbarkh";
import AtashsuziMarhunatiKH from "../components/Khesarat/AtashsuziMarhunatiKH";
import Map_freeKH from "../components/Khesarat/Map_freeKH";
import EtelaatSHoab from "../components/EtelaatShoab/EtelaatSHoab";
import EstelamResult from "../components/Inquiry/EstelamResult";
import NewsList from "../components/News/NewsList";
import SingleNews from "../components/News/SingleNews";
import ReceivedMessages from "../components/Messages/ReceivedMessages";
import MessageSingle from "../components/Messages/MessageSingle";
import NearestAgancy from "../components/Namayandegi/NearestAgancy";
import NearestBranches from "../components/Namayandegi/NearestBranches";
import Profile from "../components/Profile/Profile";
import Search from "../components/Search/Search"; 
import ChangePassword from "../components/Profile/ChangePassword";
import DarmanKH from "../components/Khesarat/DarmanKH";
import MapView from "../components/ListView/MapView"
// var PageManager = framework.PageManager ;
var PageData = framework.PageData ;

var Config = {} ;
Config.domain_pic = "https://mteammobappservices.novininsurance.com/api/PicContestApi/";
Axios.defaults.headers.common['HeaderToken'] = "b6c48337-0331-4bb0-ac6e-aa6e5b66fb54" ;

ui.Preloader.setUp('#b41d8d');

Config.allPages = [];
Config.menuPages = [];

Config.p_home = new PageData('/home','خانه',Home);
framework.PageManager.registerPage(Config.p_home);
Config.allPages.push(Config.p_home);
Config.menuPages.push(Config.p_home);

Config.p_login = new PageData('/login','ورود',Login);
framework.PageManager.registerPage(Config.p_login);
Config.allPages.push(Config.p_login);

Config.p_list = new PageData('/list','بیمه نامه های من',ListCollapse);
framework.PageManager.registerPage(Config.p_list);
Config.allPages.push(Config.p_list);
Config.menuPages.push(Config.p_list);

Config.p_khesarat = new PageData('/khesarat','خسارت های من',Khesarat);
framework.PageManager.registerPage(Config.p_khesarat);
Config.allPages.push(Config.p_khesarat);
Config.menuPages.push(Config.p_khesarat);

Config.p_pardakhtman = new PageData('/pardakhtman','پرداخت های من',SearchList);
framework.PageManager.registerPage(Config.p_pardakhtman);
Config.allPages.push(Config.p_pardakhtman);
Config.menuPages.push(Config.p_pardakhtman);

Config.p_details = new PageData('/details','جزئیات',Details);
framework.PageManager.registerPage(Config.p_details);
Config.allPages.push(Config.p_details);

Config.p_daryaftmaan = new PageData('/daryaftmaan','مشاهده دریافت های من',daryaftman);
framework.PageManager.registerPage(Config.p_daryaftmaan);
Config.allPages.push(Config.p_daryaftmaan);
Config.menuPages.push(Config.p_daryaftmaan);

Config.p_estelam = new PageData('/estelam','استعلام قیمت بیمه نامه',Inquiry);
framework.PageManager.registerPage(Config.p_estelam);
Config.allPages.push(Config.p_estelam);
Config.menuPages.push(Config.p_estelam);

Config.p_tarhha = new PageData('/tarhha','طرح ها و جشنواره ها',NewsList);
framework.PageManager.registerPage(Config.p_tarhha);
Config.allPages.push(Config.p_tarhha);
Config.menuPages.push(Config.p_tarhha);

Config.p_branches = new PageData('/branches','اطلاعات شعب (صدور و خسارت)',ListViewBranch);
framework.PageManager.registerPage(Config.p_branches);
Config.allPages.push(Config.p_branches);
Config.menuPages.push(Config.p_branches);

Config.p_namayande = new PageData('/namayande','اطلاعات نمایندگی (صدور)',ListViewNamayandegi);
framework.PageManager.registerPage(Config.p_namayande);
Config.allPages.push(Config.p_namayande);
Config.menuPages.push(Config.p_namayande);

Config.p_bimesalessayer = new PageData('/bimesalessayer','اطلاعات بیمه ثالث سایر شرکت ها',Bimenamesalessayer);
framework.PageManager.registerPage(Config.p_bimesalessayer);
Config.allPages.push(Config.p_bimesalessayer);
Config.menuPages.push(Config.p_bimesalessayer);

Config.p_bimesalessayerresult = new PageData('/bimesalessayerresult','خروجی اطلاعات بیمه نامه ثالث سایر شرکت ها',BimenamesalessayerResult);
framework.PageManager.registerPage(Config.p_bimesalessayerresult);
Config.allPages.push(Config.p_bimesalessayerresult);


Config.p_pishnahad = new PageData('/pishnahad','پیشنهادها و انتقادها',Pishnehadha);
framework.PageManager.registerPage(Config.p_pishnahad);
Config.allPages.push(Config.p_pishnahad);
Config.menuPages.push(Config.p_pishnahad);

Config.p_contact = new PageData('/contact','تماس با ما');
framework.PageManager.registerPage(Config.p_contact);
Config.allPages.push(Config.p_contact);
//Config.menuPages.push(Config.p_contact);

Config.p_contact = new PageData('/post','خبر',Post);
framework.PageManager.registerPage(Config.p_contact);
Config.allPages.push(Config.p_contact);

Config.p_atashsuzi = new PageData('/fire','بیمه نامه آتش سوزی',AtashSuzi);
framework.PageManager.registerPage(Config.p_atashsuzi);
Config.allPages.push(Config.p_atashsuzi);

Config.p_badane = new PageData('/badane','بیمه نامه بدنه',Badane);
framework.PageManager.registerPage(Config.p_badane);
Config.allPages.push(Config.p_badane);

Config.p_havadesguruhi = new PageData('/havadesguruhi','حوادث گروهی',HavadesGuruhi);
framework.PageManager.registerPage(Config.p_havadesguruhi);
Config.allPages.push(Config.p_havadesguruhi);

Config.p_atashsuzigheirSanati = new PageData('/atashsuzigheirSanati','آتش سوزی غیر صنعتی',AtashsuziGHeirSanati);
framework.PageManager.registerPage(Config.p_atashsuzigheirSanati);
Config.allPages.push(Config.p_atashsuzigheirSanati);

Config.p_atashsuzimaskuni = new PageData('/atashsuzimaskuni','آتش سوزی مسکونی',AtashsuziMaskuni);
framework.PageManager.registerPage(Config.p_atashsuzimaskuni);
Config.allPages.push(Config.p_atashsuzimaskuni);

Config.p_atashsuzianbar = new PageData('/atashsuzianbar','آتش سوزی انبار',AtashSuziAnbar);
framework.PageManager.registerPage(Config.p_atashsuzianbar);
Config.allPages.push(Config.p_atashsuzianbar);

Config.p_barbaridakheli = new PageData('/barbaridakheli','باربری داخلی',BarbariDakheli);
framework.PageManager.registerPage(Config.p_barbaridakheli);
Config.allPages.push(Config.p_barbaridakheli);

Config.p_barbarivaredati = new PageData('/barbarivaredati','باربری وارداتی',BarbariVaredati);
framework.PageManager.registerPage(Config.p_barbarivaredati);
Config.allPages.push(Config.p_barbarivaredati);

Config.p_barbarisaderati = new PageData('/barbarisaderati','باربری صادراتی',BarbariSaderati);
framework.PageManager.registerPage(Config.p_barbarisaderati);
Config.allPages.push(Config.p_barbarisaderati);

Config.p_pezeshkan = new PageData('/pezeshkan','پزشکان',Pezeshkan);
framework.PageManager.registerPage(Config.p_pezeshkan);
Config.allPages.push(Config.p_pezeshkan);

Config.p_pirapezeshkan = new PageData('/pirapezeshkan','پیراپزشکان',PiraPezeshkan);
framework.PageManager.registerPage(Config.p_pirapezeshkan);
Config.allPages.push(Config.p_pirapezeshkan);

Config.p_hamlonaghl = new PageData('/hamlonaghl','حمل ونقل',Hamlonaghl);
framework.PageManager.registerPage(Config.p_hamlonaghl);
Config.allPages.push(Config.p_hamlonaghl);

Config.p_abnie = new PageData('/abnie','سازندگان ابنیه',Abnie);
framework.PageManager.registerPage(Config.p_abnie);
Config.allPages.push(Config.p_abnie);

Config.p_sanati = new PageData('/sanati','صنعتی بازرگانی خدماتی',Sanati);
framework.PageManager.registerPage(Config.p_sanati);
Config.allPages.push(Config.p_sanati);

Config.p_omrani = new PageData('/omrani','عمرانی',Omrani);
framework.PageManager.registerPage(Config.p_omrani);
Config.allPages.push(Config.p_omrani);

Config.p_karfarmasakhtemani = new PageData('/karfarmasakhtemani','کارفرما ساختمانی',KarfarmaSakhtemani);
framework.PageManager.registerPage(Config.p_karfarmasakhtemani);
Config.allPages.push(Config.p_karfarmasakhtemani);

Config.p_madani = new PageData('/madani','مدنی',Madani);
framework.PageManager.registerPage(Config.p_madani);
Config.allPages.push(Config.p_madani);

Config.p_omrosarmayegozari = new PageData('/omrosarmayegozari','عمر و سرمایه گذاری',OmrvaSarmayegozari);
framework.PageManager.registerPage(Config.p_omrosarmayegozari);
Config.allPages.push(Config.p_omrosarmayegozari);

Config.p_mashinalat = new PageData('/mashinalat','ماشین آلات پیمانکاری',MashinAlat);
framework.PageManager.registerPage(Config.p_mashinalat);
Config.allPages.push(Config.p_mashinalat);

Config.p_sazehayetakmilshode = new PageData('/sazehayetakmilshode','سازه های تکمیل شده',SazehayeTakmilshode);
framework.PageManager.registerPage(Config.p_sazehayetakmilshode);
Config.allPages.push(Config.p_sazehayetakmilshode);

Config.p_shekastmashinalat = new PageData('/shekastmashinalat','شکست ماشین آلات',SHekastMashinAlat);
framework.PageManager.registerPage(Config.p_shekastmashinalat);
Config.allPages.push(Config.p_shekastmashinalat);

Config.p_tajhizatelekteroniki = new PageData('/tajhizatelekteroniki','تجهیزات الکترونیکی',TajhizatElekteroniki);
framework.PageManager.registerPage(Config.p_tajhizatelekteroniki);
Config.allPages.push(Config.p_tajhizatelekteroniki);

Config.p_tamamkhatar = new PageData('/tamamkhatar','تمام خطر',Tamamkhatar);
framework.PageManager.registerPage(Config.p_tamamkhatar);
Config.allPages.push(Config.p_tamamkhatar);

Config.p_sayer = new PageData('/sayer','تمام خطر',Sayer);
framework.PageManager.registerPage(Config.p_sayer);
Config.allPages.push(Config.p_sayer);

Config.p_havapeyma = new PageData('/havapeyma','هواپیما',Havapeyma);
framework.PageManager.registerPage(Config.p_havapeyma);
Config.allPages.push(Config.p_havapeyma);

Config.p_puldarjaryan = new PageData('/puldarjaryan','پول در جریان',PulDarJaryan);
framework.PageManager.registerPage(Config.p_puldarjaryan);
Config.allPages.push(Config.p_puldarjaryan);


Config.p_Keshti = new PageData('/Keshti','کشتی',Keshti);
framework.PageManager.registerPage(Config.p_Keshti);
Config.allPages.push(Config.p_Keshti);

Config.p_axa = new PageData('/axa','آکسا',Axa);
framework.PageManager.registerPage(Config.p_axa);
Config.allPages.push(Config.p_axa);

Config.p_sos = new PageData('/sos','sos',SOS);
framework.PageManager.registerPage(Config.p_sos);
Config.allPages.push(Config.p_sos);

Config.p_mapfree = new PageData('/mapfree','sos',MapFree);
framework.PageManager.registerPage(Config.p_mapfree);
Config.allPages.push(Config.p_mapfree);

Config.p_havadesenferadi = new PageData('/havadesenferadi','حوادث انفرادی',HavadesEnferadi);
framework.PageManager.registerPage(Config.p_havadesenferadi);
Config.allPages.push(Config.p_havadesenferadi);

Config.p_tamamkhatarpeymankari = new PageData('/tamamkhatarpeymankari','تمام خطر پیمانکاری',TamamKHatarPeymankari);
framework.PageManager.registerPage(Config.p_tamamkhatarpeymankari);
Config.allPages.push(Config.p_tamamkhatarpeymankari);

Config.p_omrguruhi = new PageData('/omrguruhi','عمرگروهی',OmrGuruhi);
framework.PageManager.registerPage(Config.p_omrguruhi);
Config.allPages.push(Config.p_omrguruhi);

Config.p_omrenferdi = new PageData('/omrenferdi','عمر انفرادی',OmrEnferadi);
framework.PageManager.registerPage(Config.p_omrenferdi);
Config.allPages.push(Config.p_omrenferdi);

Config.p_marhunati = new PageData('/marhunati','آتش سوزی مرهوناتی',Marhunati);
framework.PageManager.registerPage(Config.p_marhunati);
Config.allPages.push(Config.p_marhunati);

Config.p_tashkilsarmaye = new PageData('/tashkilsarmaye','تشکیل سرمایه',TashkilSarmaye);
framework.PageManager.registerPage(Config.p_tashkilsarmaye);
Config.allPages.push(Config.p_tashkilsarmaye);

Config.p_darman = new PageData('/darman','درمان',Darman);
framework.PageManager.registerPage(Config.p_darman);
Config.allPages.push(Config.p_darman);

Config.p_oyoubasasivapenhan = new PageData('/oyoubasasivapenhan','عیوب اساسی و پنهان',OyoubAsasiVapenhan);
framework.PageManager.registerPage(Config.p_oyoubasasivapenhan);
Config.allPages.push(Config.p_oyoubasasivapenhan);

Config.p_asb = new PageData('/asb','اسب',ASB);
framework.PageManager.registerPage(Config.p_asb);
Config.allPages.push(Config.p_asb);


Config.p_puldarsandogh = new PageData('/puldarsandogh','پول در صندوق',PulDarSandogh);
framework.PageManager.registerPage(Config.p_puldarsandogh);
Config.allPages.push(Config.p_puldarsandogh);

Config.p_havalekhesarat = new PageData('/havalekhesarat','حواله خسارت',HavaleKHesarat);
framework.PageManager.registerPage(Config.p_havalekhesarat);
Config.allPages.push(Config.p_havalekhesarat);

Config.p_barbaridakhelikh = new PageData('/barbaridakhelikh','خسارت باربری داخلی',BarBariDakheliKH);
framework.PageManager.registerPage(Config.p_barbaridakhelikh);
Config.allPages.push(Config.p_barbaridakhelikh);

Config.p_sales = new PageData('/sales',' ثالث جانی',Sales);
framework.PageManager.registerPage(Config.p_sales);
Config.allPages.push(Config.p_sales);

Config.p_salesmali = new PageData('/salesmali','ثالث مالی',SalesMali);
framework.PageManager.registerPage(Config.p_salesmali);
Config.allPages.push(Config.p_salesmali);

Config.p_salessarneshin = new PageData('/salessarneshin','ثالث سرنشین',SarNeshin);
framework.PageManager.registerPage(Config.p_salessarneshin);
Config.allPages.push(Config.p_salessarneshin);

Config.p_atashsuzisanati = new PageData('/atashsuzisanati','آتش سوزی صنعتی',AtashSuziSanati);
framework.PageManager.registerPage(Config.p_atashsuzisanati);
Config.allPages.push(Config.p_atashsuzisanati);

Config.p_atashsuzigheirsanatikh = new PageData('/atashsuzigheirsanatikh','آتش سوزی غیر صنعتی',AtashSuziGHeirSanatiKH);
framework.PageManager.registerPage(Config.p_atashsuzigheirsanatikh);
Config.allPages.push(Config.p_atashsuzigheirsanatikh);

Config.p_badanekh = new PageData('/badanekh','بدنه',BadaneKH);
framework.PageManager.registerPage(Config.p_badanekh);
Config.allPages.push(Config.p_badanekh);

Config.p_havadesguruhikh = new PageData('/havadesguruhikh','حوادث گروهی',HavadesGuruhiKH);
framework.PageManager.registerPage(Config.p_havadesguruhikh);
Config.allPages.push(Config.p_havadesguruhikh);

Config.p_havadesenferadikh = new PageData('/havadesenferadikh','حوادث انفرادی',HavadesEnferadiKH);
framework.PageManager.registerPage(Config.p_havadesenferadikh);
Config.allPages.push(Config.p_havadesenferadikh);

Config.p_barbarivaredatikh = new PageData('/barbarivaredatikh','باربری وارداتی',BarbariVaredatikh);
framework.PageManager.registerPage(Config.p_barbarivaredatikh);
Config.allPages.push(Config.p_barbarivaredatikh);

Config.p_barbarisaderatikh = new PageData('/barbarisaderatikh','باربری وارداتی',BarbariSaderatikh);
framework.PageManager.registerPage(Config.p_barbarisaderatikh);
Config.allPages.push(Config.p_barbarisaderatikh);

Config.p_pezeshkankh = new PageData('/pezeshkankh','پزشکان',PezeshkanKH);
framework.PageManager.registerPage(Config.p_pezeshkankh);
Config.allPages.push(Config.p_pezeshkankh);

Config.p_pirapezeshkankh = new PageData('/pirapezeshkankh','پیراپزشکان',PiraPezeshkanKH);
framework.PageManager.registerPage(Config.p_pirapezeshkankh);
Config.allPages.push(Config.p_pirapezeshkankh);

Config.p_hamlonaghlkh = new PageData('/hamlonaghlkh','حمل و نقل',HamlonaghlKH);
framework.PageManager.registerPage(Config.p_hamlonaghlkh);
Config.allPages.push(Config.p_hamlonaghlkh);

Config.p_abniekh = new PageData('/abniekh','ابنیه',AbnieKH);
framework.PageManager.registerPage(Config.p_abniekh);
Config.allPages.push(Config.p_abniekh);

Config.p_sanatibazarganikh = new PageData('/sanatibazarganikh','صنعتی بازرگانی خدماتی',SanatiBazarganiKH);
framework.PageManager.registerPage(Config.p_sanatibazarganikh);
Config.allPages.push(Config.p_sanatibazarganikh);

Config.p_omranikh = new PageData('/omranikh','صنعتی بازرگانی خدماتی',OmraniKH);
framework.PageManager.registerPage(Config.p_omranikh);
Config.allPages.push(Config.p_omranikh);

Config.p_karfarmasakhtemanikh = new PageData('/karfarmasakhtemanikh',';کارفرما ساختمانی',KarfarmaSakhtemaniKH);
framework.PageManager.registerPage(Config.p_karfarmasakhtemanikh);
Config.allPages.push(Config.p_karfarmasakhtemanikh);

Config.p_madanikh = new PageData('/madanikh',';مدنی',MadaniKH);
framework.PageManager.registerPage(Config.p_madanikh);
Config.allPages.push(Config.p_madanikh);

Config.p_omrsarmayegozarikh = new PageData('/omrsarmayegozarikh',';عمروسرمایه گذاری',OmrVaSarmayegozariKH);
framework.PageManager.registerPage(Config.p_omrsarmayegozarikh);
Config.allPages.push(Config.p_omrsarmayegozarikh);

Config.p_axakh = new PageData('/axakh',';آکسا',AxaKH);
framework.PageManager.registerPage(Config.p_axakh);
Config.allPages.push(Config.p_axakh);

Config.p_asbkh = new PageData('/asbkh',';اسب',ASBKH);
framework.PageManager.registerPage(Config.p_asbkh);
Config.allPages.push(Config.p_asbkh);

Config.p_soskh = new PageData('/soskh',';sos',SosKH);
framework.PageManager.registerPage(Config.p_soskh);
Config.allPages.push(Config.p_soskh);

Config.p_mashinalatkh = new PageData('/mashinalatkh',';ماشین آلات پیمانکاری',MashinAlatPeymankarikh);
framework.PageManager.registerPage(Config.p_mashinalatkh);
Config.allPages.push(Config.p_mashinalatkh);

Config.p_tajhizatelektronikikh = new PageData('/tajhizatelektronikikh',';تجهیزات الکترونیکی',TajhizatElektronikiKH);
framework.PageManager.registerPage(Config.p_tajhizatelektronikikh);
Config.allPages.push(Config.p_tajhizatelektronikikh);

Config.p_sazehayetakmilshodekh = new PageData('/sazehayetakmilshodekh',';سازه های تکمیل شده',SazehayeTakmilshodeKH);
framework.PageManager.registerPage(Config.p_sazehayetakmilshodekh);
Config.allPages.push(Config.p_sazehayetakmilshodekh);

Config.p_shekastmashinalatkh = new PageData('/shekastmashinalatkh',';شکست ماشین آلات',SHekastMashinAlatKH);
framework.PageManager.registerPage(Config.p_shekastmashinalatkh);
Config.allPages.push(Config.p_shekastmashinalatkh);

Config.p_tamamkhatarkh = new PageData('/tamamkhatarkh',';تمام خطر',TamamkhatarKH);
framework.PageManager.registerPage(Config.p_tamamkhatarkh);
Config.allPages.push(Config.p_tamamkhatarkh);

Config.p_sayerkh = new PageData('/sayerkh',';سایر',SayerKH);
framework.PageManager.registerPage(Config.p_sayerkh);
Config.allPages.push(Config.p_sayerkh);

Config.p_havapeymakh = new PageData('/havapeymakh',';هواپیما',HavapeymaKH);
framework.PageManager.registerPage(Config.p_havapeymakh);
Config.allPages.push(Config.p_havapeymakh);

Config.p_poolkh = new PageData('/poolkh',';پول در جریان',PoolKH);
framework.PageManager.registerPage(Config.p_poolkh);
Config.allPages.push(Config.p_poolkh);

Config.p_poolsandoghkh = new PageData('/poolsandoghkh',';پول در صندوق',PoolSandoghKH);
framework.PageManager.registerPage(Config.p_poolsandoghkh);
Config.allPages.push(Config.p_poolsandoghkh);

Config.p_maskunikh = new PageData('/maskunikh',';آتش سوزی مسکونی',AtashSuziMaskuniKH);
framework.PageManager.registerPage(Config.p_maskunikh);
Config.allPages.push(Config.p_maskunikh);

Config.p_anbarkh = new PageData('/anbarkh',';آتش سوزی انبار',AtashSuziAnbarkh);
framework.PageManager.registerPage(Config.p_anbarkh);
Config.allPages.push(Config.p_anbarkh);

Config.p_marhunatikh = new PageData('/marhunatikh',';آتش سوزی مرهوناتی',AtashsuziMarhunatiKH);
framework.PageManager.registerPage(Config.p_marhunatikh);
Config.allPages.push(Config.p_marhunatikh);

Config.p_mapfreekh = new PageData('/mapfreekh',';Map_free',Map_freeKH);
framework.PageManager.registerPage(Config.p_mapfreekh);
Config.allPages.push(Config.p_mapfreekh);

Config.p_etelaatshoab = new PageData('/etelaatshoab',';اطلاعات شعب',EtelaatSHoab);
framework.PageManager.registerPage(Config.p_etelaatshoab);
Config.allPages.push(Config.p_etelaatshoab);

Config.p_estelamresult = new PageData('/estelamresult',';استعلام قیمت بیمه نامه',EstelamResult);
framework.PageManager.registerPage(Config.p_estelamresult);
Config.allPages.push(Config.p_estelamresult);

Config.p_news = new PageData('/news','اخبار',NewsList);
framework.PageManager.registerPage(Config.p_news);
Config.allPages.push(Config.p_news);

Config.p_singlenews = new PageData('/singlenews','صفحه خبر',SingleNews);
framework.PageManager.registerPage(Config.p_singlenews);
Config.allPages.push(Config.p_singlenews);

Config.p_receivedmessages = new PageData('/receivedmessages','پیام ها',ReceivedMessages);
framework.PageManager.registerPage(Config.p_receivedmessages);
Config.allPages.push(Config.p_receivedmessages);
Config.menuPages.push(Config.p_receivedmessages);

Config.p_receivedsinglemessage = new PageData('/receivedsinglemessage','پیام ',MessageSingle);
framework.PageManager.registerPage(Config.p_receivedsinglemessage);
Config.allPages.push(Config.p_receivedsinglemessage);

Config.p_nearestagency = new PageData('/nearestagency','نزدیکترین نمایندگی به من ',NearestAgancy);
framework.PageManager.registerPage(Config.p_nearestagency);
Config.allPages.push(Config.p_nearestagency);

Config.p_nearestbranches = new PageData('/nearestbranches','نزدیکترین شعب به من ',NearestBranches);
framework.PageManager.registerPage(Config.p_nearestbranches);
Config.allPages.push(Config.p_nearestbranches);

Config.p_profileinfo = new PageData('/profileinfo','حساب کاربری ',Profile);
framework.PageManager.registerPage(Config.p_profileinfo);
Config.allPages.push(Config.p_profileinfo);

Config.p_changepassword = new PageData('/changepassword','تغییر رمز عبور ',ChangePassword);
framework.PageManager.registerPage(Config.p_changepassword);
Config.allPages.push(Config.p_changepassword);

Config.p_search = new PageData('/search','تغییر رمز عبور ',Search);
framework.PageManager.registerPage(Config.p_search);
Config.allPages.push(Config.p_search);

Config.p_darmankh = new PageData('/darmankh','درمان ',DarmanKH);
framework.PageManager.registerPage(Config.p_darmankh);
Config.allPages.push(Config.p_darmankh);

Config.p_viewonmap = new PageData('/viewonmap','نمایش روی نقشه ',MapView);
framework.PageManager.registerPage(Config.p_viewonmap);
Config.allPages.push(Config.p_viewonmap);

export default Config ;


// WEBPACK FOOTER //
// ./src/Core/Config.js